import { render, staticRenderFns } from "./RightSideMenu.vue?vue&type=template&id=5205e126"
import script from "./RightSideMenu.vue?vue&type=script&lang=ts"
export * from "./RightSideMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports